export function getTenantFromHostname(hostname: string): string {
    const labels = hostname.split('.').filter(Boolean)
    if (labels.length < 3) {
        throw new Error(
            `Não foi possível determinar o tenant a partir do host "${hostname}". O host precisa ter um subdomínio de tenant (ex: philos.dominio.com).`
        )
    }
    return labels[0]
}

export function getTenant(): string {
    return getTenantFromHostname(window.location.hostname)
}
